/**
 * @module builder
 */
import type { QuoteDocument } from 'paintscout'

/**
 * Set (or clear) a line item's `hideOnWorkOrder` flag — the estimate's "Hidden on Work Order"
 * checkbox. The work order hides its line-item cards through this same flag rather than through
 * `quote.workOrderLayout`, so hiding a line-item card on the work order ticks the estimate's
 * checkbox and restoring it from the "Hidden items" panel clears it (ENG-1930).
 *
 * The flag is dropped rather than written as `false`, so an untouched line item stays untouched.
 * Returns the quote unchanged when the key isn't a line item on it.
 */
export function setLineItemHiddenOnWorkOrder(args: {
  quote: QuoteDocument
  key: string
  hidden: boolean
}): QuoteDocument {
  const { quote, key, hidden } = args
  const lineItem = quote.lineItems?.[key]
  if (!lineItem) {
    return quote
  }
  const nextItem = { ...lineItem }
  if (hidden) {
    nextItem.hideOnWorkOrder = true
  } else {
    delete nextItem.hideOnWorkOrder
  }
  return { ...quote, lineItems: { ...quote.lineItems, [key]: nextItem } }
}
